import {PRICES_CITIES} from "@pg-rp/navigation";

import type {IParsedPricesSearchQuery} from "../../types/IPricesSearchModel";
import {normalizeSearchText} from "../normalize_search_text";

export interface IPricesCityMatch {
    slug: string;
    /** Canonical name ("Łódź"). */
    name: string;
}

// RCN matches diacritics literally ("lodz" finds nothing), so the names of the 14 cities are the one thing the front
// can restore on its own: "lodz" → "łódź", "krakow" → "kraków". Street names cannot be fixed this way.
const PRICES_CITY_BY_NORMALIZED_NAME: ReadonlyMap<string, IPricesCityMatch> = new Map(
    PRICES_CITIES.map((city) => [normalizeSearchText(city.name), {slug: city.slug, name: city.name}])
);

/** One of the 14 prices cities by its name in any case, with or without diacritics ("lodz", "ŁÓDŹ", "łódź"). */
export const findPricesCityByName = (name: string): IPricesCityMatch | null => PRICES_CITY_BY_NORMALIZED_NAME.get(normalizeSearchText(name)) ?? null;

/** Rewrites a whole token that spells a prices city without its diacritics; partial tokens ("lod") stay as typed. */
export const resolveTokenDiacritics = (token: string): string => {
    const city = findPricesCityByName(token);

    return city ? city.name.toLocaleLowerCase("pl") : token;
};

export const resolveQueryDiacritics = (tokens: readonly string[]): {tokens: string[]; isRewritten: boolean} => {
    const resolved = tokens.map(resolveTokenDiacritics);

    return {tokens: resolved, isRewritten: resolved.some((token, index) => token !== tokens[index])};
};

/** The phrase of "Pokazujemy wyniki dla „łódź”" - only when a token was rewritten for RCN and something was found. */
export const getDiacriticsBannerPhrase = (parsed: IParsedPricesSearchQuery, hasResults: boolean): string | null =>
    hasResults && parsed.diacriticPhrase ? parsed.diacriticPhrase : null;
import {PRICES_CITIES} from "@pg-rp/navigation";

import type {IParsedPricesSearchQuery} from "../../types/IPricesSearchModel";
import {normalizeSearchText} from "../normalize_search_text";

export interface IPricesCityMatch {
    slug: string;
    /** Canonical name ("Łódź"). */
    name: string;
}

// RCN matches diacritics literally ("lodz" finds nothing), so the names of the 14 cities are the one thing the front
// can restore on its own: "lodz" → "łódź", "krakow" → "kraków". Street names cannot be fixed this way.
const PRICES_CITY_BY_NORMALIZED_NAME: ReadonlyMap<string, IPricesCityMatch> = new Map(
    PRICES_CITIES.map((city) => [normalizeSearchText(city.name), {slug: city.slug, name: city.name}])
);

/** One of the 14 prices cities by its name in any case, with or without diacritics ("lodz", "ŁÓDŹ", "łódź"). */
export const findPricesCityByName = (name: string): IPricesCityMatch | null => PRICES_CITY_BY_NORMALIZED_NAME.get(normalizeSearchText(name)) ?? null;

/** Rewrites a whole token that spells a prices city without its diacritics; partial tokens ("lod") stay as typed. */
export const resolveTokenDiacritics = (token: string): string => {
    const city = findPricesCityByName(token);

    return city ? city.name.toLocaleLowerCase("pl") : token;
};

export const resolveQueryDiacritics = (tokens: readonly string[]): {tokens: string[]; isRewritten: boolean} => {
    const resolved = tokens.map(resolveTokenDiacritics);

    return {tokens: resolved, isRewritten: resolved.some((token, index) => token !== tokens[index])};
};

/** The phrase of "Pokazujemy wyniki dla „łódź”" - only when a token was rewritten for RCN and something was found. */
export const getDiacriticsBannerPhrase = (parsed: IParsedPricesSearchQuery, hasResults: boolean): string | null =>
    hasResults && parsed.diacriticPhrase ? parsed.diacriticPhrase : null;
